import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

const RESPONSE_CANCEL = 1;

@Component({
	selector: 'copo-dialog-error',
	templateUrl: './dialog-error.component.html',
	styleUrl: './dialog-error.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatButtonModule, MatIconModule, MatDialogModule]
})
export class DialogErrorComponent {
	dialogError: string | undefined;

	constructor(

		private readonly dialogRef: MatDialogRef<DialogErrorComponent, number>
	) {}

	evtCancel() {
		this.dialogRef.close(RESPONSE_CANCEL);
	}
}
